import LinearProgress, {
  linearProgressClasses,
} from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';
import * as React from 'react';
import {
  valueHandler,
  handleColorSelection,
} from '../helpers/progressValueColor';

const defaultRules = {
  success: {
    top: 100,
    bottom: 100,
  },
  warning: {
    top: 99,
    bottom: 50,
  },
};

const ProgressBar = ({ progressValue, rules = defaultRules }) => {
  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 8,
    borderRadius: 5,
    backgroundColor:
      theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
    },
  }));

  return (
    <BorderLinearProgress
      variant="determinate"
      value={valueHandler(progressValue)}
      color={handleColorSelection(valueHandler(progressValue), rules)}
      data-testid={'bar-color'}
    />
  );
};

export default ProgressBar;
